<a [routerLink]="[route()]" class="tree-workflow-row" [class.is-active]="isActive()">
  <span class="tree-branch" aria-hidden="true"></span>
  <span class="tree-workflow-icon-badge" [style.background]="iconBackdropBackground()">
    <app-workflow-icon-display
      [iconKey]="icon()"
      glyphClass="h-3.5 w-3.5 tree-workflow-icon"
      imgClass="h-3.5 w-3.5 rounded object-cover"
    />
  </span>
  <span class="tree-workflow-name">{{ name() }}</span>
</a>
